<template>
  <!--
    icon="mdi-vuetify"
  -->
  <base-section
    id="doom"
    class="blue lighten-5"
  >
    <!--
    <base-section-heading
      color="grey lighten-2"
      title="About Us"
    />
    -->
    <v-container class="">
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="12"
        >
          <!--
          -->
          <base-info-card
            v-bind="card"
            :color="primary"
            :background="primary"
          />
          <v-btn
            ref="button"
            text
            small
            color="primary"
            @click="handleClick('HeroClimate')"
          >
            Scroll To TOP
          </v-btn>
        </v-col>
      </v-row>
      <span class="trace">Doom.vue</span>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionAboutUs',

    data: () => ({
      cards: [
        /*
        {
          title: 'Immediate Steps',
          subtitle: '',
          text: 'We provide information about local environmental issues and resources and organize practical projects aimed at reducing Truro’s collective carbon footprint and safeguarding Truro’s ecosystems.',
          callout: '',
        },
        {
          title: 'Our Vision',
          subtitle: '',
          text: 'We envision a resilient, ecologically healthy, environmentally responsible community living without pollutants in our air, water, and land.',
          callout: '',
        },
        */
        {
          title: 'Doom',
          // subtitle: 'Why this is an emergency',
          posttitle: 'Why this is an emergency',
          html: "<span id='sectionTopDoom'><small></small></span><p>The climate crisis is a strange kind of emergency, for at least five reasons. </p><p>First, it's unfathomably huge. It’s the biggest threat humanity has ever faced. Get ready: we’re going to be real here, and speak to you as an adult. If we stay on our current path of carbon emissions, it will wreak untold calamity all over the world: death, destruction, disease, famine, economic collapse, and war. There will be suffering almost everywhere, including Truro. </p><p>Second, nobody’s really talking about it in properly alarming terms. Few scientists, elected officials, or journalists want to admit the extent of the danger, because of fear of being called extreme, or scaring people off. The rest of us don’t either, because we don’t want to face the truth, bring our friends down, or be called alarmist. And most of us are in some degree of denial about the true extent of the crisis.</p><p>Third, its solutions—the measures needed to avert catastrophe—are so big that they seem both frightening and impossible. Because they require change, we feel threatened by them, and don’t face them. And that leads to the belief that they would add up to a worse life than the one we currently lead, when the opposite is actually true!</p><p>Fourth, its consequences still seem far away geographically. The deaths are happening—<a href='https://www.americansecurityproject.org/climate-change-causing-400000-deaths-per-year/' target='blank'>already 400,000 per year</a>—but not in Truro. They’re happening mostly to non-white people in the developing world, where drought is leading to crop failure, mass migration, and war. Thinking about that causes guilty feelings we don’t want to face. The suffering is also happening, but not in Truro. In the US, it’s in fire country, tornado country, flood country, and border country—where families fleeing climate-related chaos in Latin America are being turned back or imprisoned by Americans who don’t want to let them in.</p><p>Fifth, its consequences still seem far off in time. When we look out our windows, Truro is as beautiful as it ever was. Everything feels basically normal and healthy. Truro’s disaster is not palpable, because it’s in the future. The worst effects of climate breakdown—deadly heatwaves, catastrophic flooding, wildfires, tropical insect-borne diseases, famine, and economic/social/political collapse—will not spread across the US for another 30-80 years. Most of Truro’s current residents won’t still be around. But our children and grandchildren will be. That’s the calamity our current lifestyle is leaving them. And because we’re on the coast, and have so many elders, who are especially vulnerable to heat-death, some of it will undoubtedly come to Truro sooner.</p><p>If catastrophe isn’t here in either place or time, what makes this an emergency for Truro? Two things. First, many of us care about the misery climate breakdown is bringing people in other parts of the US and world, even if they don’t look like us. Because it is partially our fault, we believe it is our responsibility to help stop it. And second, humanity’s only chance to stop that misery from spreading everywhere in the coming three to eight decades, including here, is to take major, heroic action <em>in this decade</em><span hidden> [Misconception #4]</span>. We must completely eliminate our carbon footprint in ten years, which will be virtually impossible unless we start right away. That’s the emergency.</p><span id='sectionEndDoom'><small></small></span>",
          callout: '',
          background: 'warning',
        },

      ],
      target: '#sectionTop',
      duration: 250,
      offset: 0,
      easing: 'easeInOutCubic',
    }),
    computed: {
      options () {
        return {
          duration: this.duration,
          offset: this.offset,
          easing: this.easing,
        }
      },
    },

    methods: {
      handleClick: function (where) {
        // this.$vuetify.goTo('scrollToNav', this.options)
        this.$vuetify.goTo(this.target + where, this.options)
        console.log('SCROLLING TO 100', this.target, where, this.options)
      },
    },

  }

        /*
We are a grassroots, informal organization, inviting all interested members of the community to participate in our work.
We are committed to educating ourselves about the local impact of climate change and to finding environmentally responsible solutions.
We are committed to social justice, focusing on the consequences of climate change and environmental actions for all members of the community.
We are committed to green development and a strong local economy benefiting local businesses and workers producing food, goods, and services.

        {
          title: 'Target Setting',
          subtitle: 'Income Flow',
          text: 'Similique sunt in culpa qui officia deserunt mollitia animi, id est laborut dolorum fuga.harum quidem rerum facilis estexpedita distinctio.',
          callout: '03',
        },
        */

</script>
